export default "__VITE_ASSET__BHEJtZ3B__"